import { render } from "./academic-industry-engagement-hub-submissions.vue?vue&type=template&id=d70cc78a"
import script from "./academic-industry-engagement-hub-submissions.vue?vue&type=script&lang=js"
export * from "./academic-industry-engagement-hub-submissions.vue?vue&type=script&lang=js"
script.render = render

export default script